import { render } from "./BaseTextCollapse.vue?vue&type=template&id=66bbaf34&scoped=true"
import script from "./BaseTextCollapse.vue?vue&type=script&lang=js"
export * from "./BaseTextCollapse.vue?vue&type=script&lang=js"

import "./BaseTextCollapse.vue?vue&type=style&index=0&id=66bbaf34&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bbaf34"]])

export default __exports__